import { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Monitor, X } from "lucide-react";

const KEY = "aura_desktop_notice_dismissed";

export const MobileNotice = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(KEY)) setShow(true);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="mobile-desktop-notice"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 26 }}
          className="lg:hidden fixed bottom-3 inset-x-3 z-[60]"
        >
          <div className="rounded-2xl border px-4 py-3 flex items-start gap-3 shadow-2xl"
            style={{ background: "rgba(20,21,28,0.96)", borderColor: "rgba(200,161,92,0.3)", backdropFilter: "blur(12px)" }}>
            <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
              style={{ background: "rgba(200,161,92,0.12)" }}>
              <Monitor className="w-4.5 h-4.5" style={{ color: "#C8A15C" }} />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-white leading-snug">Desktop-first studio</p>
              <p className="text-xs text-[#A1A1AA] mt-0.5 leading-relaxed">
                AuraSession works on your phone, but full sessions — MIDI, DAW packages and sample matching —
                are built for <span className="text-[#E4C88C]">Mac &amp; desktop</span>. Open on a computer for the real thing.
              </p>
            </div>
            <button data-testid="mobile-notice-dismiss" onClick={dismiss}
              className="text-[#71717A] hover:text-white shrink-0 -mt-0.5" aria-label="Dismiss">
              <X className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
